<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">個人情報保護方針</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">個人情報保護方針</h3>
    </div>
    <div class="page-block__inner">
      <div class="privacy-area">
        <h4>第1条：定義</h4>
        <p>
          本プライバシーポリシーにおいて「個人情報」とは、個人情報の保護に関する法律に規定されるのと同一の意味を有します。なお、クッキー情報、ＩＰア ドレス情報及び携帯電話の識別番号は、
          これらの情報のみでは特定の個人を識別できず、「
          他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるもの」でもないため、個人情報とは扱いません。
        </p>
        <h4>第2条：個人情報の取得</h4>
        <p>当社は、個人情報を適正に取得し、偽りその他不正の手段により取得することはありません。</p>
        <p>当社は、本サービスの提供にあたり、以下の情報を取得します。</p>
        <p>
          ・氏名<br>
          ・住所<br>
          ・生年月日<br>
          ・メールアドレス<br>
          ・電話番号<br>
          ・本人確認書類に記載された情報<br>
          ・その他当社が本サービスの提供または本人確認のために必要と判断する情報
        </p>
        <!-- eslint-disable max-len -->
        <p>
          なお、本人確認書類としてマイナンバーカード等をご提出いただく場合、ご本人様確認並びに次条に規定する目的のみに使用し、その他の目的外利用はしません。したがいまして、右目的に必要最小限の情報取得とすべく、ユーザーは当該番号部分を判読不能な状態にマスキングしたうえで提出するものとします。<br>
          なお、その他の公的書面を本人確認用資料としてご提出される場合、当社基準に基づき、本人確認の是非を判断させていただきますので、マイナンバーカードのご提出を推奨させていただきます。
        </p>
        <!-- eslint-enable max-len -->
        <h4>第3条：利用目的の通知・公表</h4>
        <p>
          当社は、個人情報を取得する場合は、法令により別段の取扱いが許容される場合を除き、下記の利用目的の限りで利用します。<br>
          【記】<br>
          ご本人との連絡やご連絡いただいた事項への対応、及び不正利用が疑われる場合のご本人確認、当社の業務改善のための内部利用。
        </p>
        <h4>第4条：利用目的による制限</h4>
        <p>当社は、法令により別段の取扱いが許容される場合を除き、あらかじめご本人の同意を得ないで、利用目的の達成に必要な範囲を超えて、個人情報を取り扱うことはありません。</p>
        <h4>第5条：利用目的の変更</h4>
        <p>
          当社は、取得した個人情報について、変更前の利用目的と相当の関連性を有すると合理的に認められる範囲内で利用目的を変更することがあります。利用目的に変更があった場合は、
          変更された利用目的について、適宜の方法（本ポリシー改訂のウェブサイト上でのアナウンス等）でご本人に通知又は公表致します。
        </p>
        <h4>第6条：個人情報の管理</h4>
        <p>
          当社は、利用目的の達成に必要な範囲内において、個人情報を正確かつ最新の内容に保つよう努めます。また、従業員に個人情報を取り扱わせる場合に
          は、法令に従い、当該従業員に対する必要かつ適切な監督を行います。<br>
          本人確認情報については、利用目的達成後、法令上必要な場合を除き、当社所定の方法により適切に削除または廃棄します。
        </p>
        <h4>第7条：委託先の監督</h4>
        <p>当社は、個人情報の取扱いの全部又は一部を委託する場合は、個人情報の安全管理が図られるよう、法令に従い、委託先に対する必要かつ適切な監督を行います。</p>
        <h4>第8条：第三者への提供</h4>
        <p>当社は、法令により許容される場合及び本人の同意がある場合を除き、個人情報を第三者に提供することはありません。</p>
        <h4>第9条：個人情報の開示・訂正・利用停止等</h4>
        <p>
          当社は、保有する個人情報の開示・訂正・利用停止等をご本人から求められたときは、ご本人に対し、法令に則り、合理的かつ必要な範囲内で遅滞なく対応いたします。
          但し、開示請求が当社所定の方法に則って行われ、当社所定の手数料をお支払いただくことを条件とします。
        </p>
        <h4>第10条：お問い合わせ先</h4>
        <p>個人情報の取扱いに関するご要望・ご質問については下記サポートまでお問い合せください。<br></p> <br>
        メールアドレス：<a
          v-if="isBtoB"
          href="mailto:support@zula.jp"
          target="_blank">support@zula.jp</a>
        <a
          v-else
          href="mailto:contact@narasu.jp"
          target="_blank">contact@narasu.jp</a>
        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back">
            トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'Privacy',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style scoped>

</style>
